
/**
 * Created by Marcus Zhao on 10/13/2019.
 *  Description:
 *      Use base template component for some logic
 * ------ maintenance history ------
 * 11/14/2019 Marcus Zhao - Add processing() function for calculate event label and field width.
 * 12/03/2019 Marcus Zhao - Add  entryform to judge keep note body info
*/
import { NoteEntry } from '../models/note-entry.model';
import { Subject, Subscription } from 'rxjs';
import { EntryType } from '../models/entry-type.model';
import { NoteBodyAction } from '../models/note-body-action.model';
import { businessConstants, NoteActions } from '../constants/business.constants';
import { AddInGlobalModel, AddInDepositType } from '../../models/addin.model';
import { OfficeAddIn } from '../models/office-addin.model';
import { ComponentTypes } from '@tamalelibs/constants/business.constants';

const width100 = '100%';
const isSwitchNote = 'isSwitchNote';
export class TemplateDialogBaseComponent {
    /***********UI flags******************** */
    allowCustom = false;
    attachmentUploading = false;
    attachmentRenaming = false;
    dialogWidth: any = 684;
    dialogWidthForPlugin = 684;
    domainUrl: string;
    eventLabelWidth = 75;
    eventContentWidth: any = 609;
    entry: NoteEntry;
    editingEntryId: string; // the entryId that is being edited, get this from routing URL
    hasGotLabelWidth = false;
    opened: boolean;
    isShowEventArea = false;
    isDialogClosedForPlugin = 10; // 10 stands for open;20 stands for close
    isShow = false;
    // Switch to a single layer layout
    isSingleTemplate = false;
    isPlugInEditNoteMode = false; // for notebody editing mode which is from office plugins.
    isPrivacy = false;
    privacyEnabled = false; // mark if privacy is enabled
    privacyListDefalult: Array<any>;
    publishButtonHasBeenClicked = false;
    // single layer template for addin or other scenario
    singleLayerConfig = [];
    sentimentConfig = {};
    titleName: string;
    valueChangeSubject: Subject<any>; // for notifying other control about value set change


    // data models
    _currentEntity: any;

    _createEntryId: string; // the entryId that is being create by blastemail, get this from routing URL
    // mark if the entities field should be disabled, disable entities field in create sidnote mode when parent note is note editable
    _disableEntityField = false;
    _destroySubscriptions: Array<Subscription> = [];
    _dropzoneSubscription$: Subscription; // global dropzone action subscription
    _delimiter = ',';
    _dirtyAttachments: string[] = [];
    _entry: any; // mark the entry value for note editing
    _el: HTMLElement;
    _filePath = ''; // mark the file path for share file to note
    _firstOpen = true; // mark if the window is opened for the first time, no matter create or edit
    _filterHandler$: Subject<string> = new Subject();
    _isPreNoteEntryForm = false; // mark the last noteType for switching notetype logic
    _isDraft = false; // mark if note template is triggered by drafts
    _noteTypes: Array<EntryType>; // save the note type dropdown data set
    _noteTypesSource: Array<EntryType>;
    _noteTypeDefalult: EntryType; // set the default not type;
    _noteTypeId: string; // save the selected note type ID
    _newEntitiesFieldValue: Array<string> = []; // mark the new eneties field values when changed in create/edit
    _noteBodyHtml = ''; // cache note body html, used when switching note types and publishing/drafting notesidenote mode
    _noteAction: string; // addNote, editNote, addSidenote, editSidenote, get this from routing URL
    _noteBodySubject: Subject<NoteBodyAction> = new Subject<NoteBodyAction>(); // for notifying note body to get note body string
    _officeAddIn: OfficeAddIn; // data from office add-in
    _previousTemplateValueSet: any = {};
    _privacyList: Array<any>;
    _privacyListSource: Array<any>;
    _processingUploads = [];
    _privacyTeam: any = {};
    _publishSubject$: Subject<any> = new Subject(); // for date components.
    _noteTypeInited = false; // mark if current note type is initialized
    // mark if a note is being saved, to prevent user clicks 'draft' or 'publish' button twice very quickly to create two duplicate notes
    _savingNote = false;
    _saveAction: string; // saveNote, saveDraft
    _tplConfig = [];
    _teamplateMsgSubscriptions: Subscription;
    _templateValueSet: any = {}; // mark the template control's values, based on
    _widthFactor = 1.2; // Calculate the Size Ratio

    accumulateTemplateValueSetChanges() {

        // tslint:disable-next-line: forin
        for (const controlId in this._templateValueSet) {
            const ctrl = this._templateValueSet[controlId];
            let adhocId;
            const adhocDefId = ctrl.adhocDefId.toString();
            if (adhocDefId.indexOf('x-') > -1) {
                adhocId = adhocDefId.slice(2).toLowerCase();
            } else {
                adhocId = adhocDefId.toLowerCase();
            }
            if (this._previousTemplateValueSet[adhocId] == null) {
                this._previousTemplateValueSet[adhocId] = {};
            }
            // handle entryform logic :if current config include entryform shouldn't keep info .
            if (ctrl.componentType === 'ckeditor-input' && this._templateValueSet[controlId].isEntryForm) {
                continue;
            } else {
                this._previousTemplateValueSet[adhocId][ctrl.componentType] = this._templateValueSet[controlId];
            }
        }
    }


    setStaticDefaultValueForEdit(config: any) {
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this.setStaticDefaultValueForEdit(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    this.processingWidthForEventWidth(ctrl);
                    // set ctrl note action first
                    ctrl.noteAction = this._noteAction;
                    ctrl['firstEdit'] = true;
                    ctrl['prefixId'] = '';
                    ctrl[isSwitchNote] = false;
                    // set ctrl statci default value when control type and adhocId matched
                    if (ctrl.controlID) {

                        let adhocId = '';
                        if (ctrl.adhocDefID) {
                            adhocId = ctrl.adhocDefID.toLowerCase();
                        } else {
                            adhocId = ctrl.controlID.toLowerCase();
                        }
                        if (this._entry && this._entry[adhocId] !== undefined) {
                            ctrl.fromEditSwitch = false;
                            // disable entities filed in create sidenote mode when parent note is not editable
                            if (ctrl.componentType === 'entity-input' && (this._noteAction === NoteActions.createSidenote
                                || this._noteAction === NoteActions.editSidenote || this._noteAction === NoteActions.editNote)) {
                                ctrl.disabled = this._disableEntityField;
                            }
                            // only 1 entity in edit draft dialog and it's Uncategorized. hide it.
                            if (adhocId === 'entities' && this._entry[adhocId].length === 1
                                && this._entry[adhocId][0] === businessConstants.entity.Uncategorized_Fixed_ID) {
                                ctrl.staticDefaultValue = [];
                            } else if (ctrl.componentType === 'date-input') {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                                ctrl.maxValue = this._entry.submittedDate;
                            } else if (ctrl.componentType === 'met-input' || ctrl.componentType === 'med-input') {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                            } else if (ctrl.componentType === 'tb-input') {
                                ctrl.staticDefaultValue = this._entry[adhocId].split('\r\n').join('\n');
                            } else if (ctrl.componentType === 'msd-input') {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                            } else if (ctrl.componentType === 'displaydate-input' && this._entry.entryClass === 'event') {
                                ctrl.readOnly = true;
                                ctrl.staticDefaultValue = new Date().getTime();
                            } else {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                            }
                        } else if (this._entry && this._entry[adhocId] === undefined) {
                            if (ctrl.componentType !== 'sentiment-input' && ctrl.componentType !== 'priority-input'
                                && ctrl.componentType !== 'ckeditor-input' && ctrl.defaultValue) {
                                ctrl.useDefaultValue = true;
                                ctrl.staticDefaultValue = undefined;
                            }
                        }
                    }
                }
            }
        }
        return config;
    }

    setStaticDefaultValueForNoteTypeSwitching(config: any, isEvent?: boolean) {
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this.setStaticDefaultValueForNoteTypeSwitching(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    this.processingWidthForEventWidth(ctrl);
                    // set ctrl note action first
                    ctrl.noteAction = this._noteAction;
                    ctrl['isDraft'] = this._isDraft;
                    ctrl['firstEdit'] = false;
                    ctrl['prefixId'] = '';
                    ctrl[isSwitchNote] = true;
                    ctrl.useDefaultValue = true;
                    // set ctrl statci default value when control type and adhocId matched
                    if (ctrl.controlID) {
                        let adhocId = '';
                        if (ctrl.adhocDefID) {
                            adhocId = ctrl.adhocDefID.toLowerCase();
                        } else {
                            adhocId = ctrl.controlID.toLowerCase();
                        }
                        if (ctrl.componentType === 'displaydate-input') {
                            ctrl.readOnly = true;
                        }

                        ctrl.fromEditSwitch = true;
                        if (this._previousTemplateValueSet && this._previousTemplateValueSet[adhocId]
                            && this._previousTemplateValueSet[adhocId][ctrl.componentType] && !ctrl.isHidden) {
                            // disable entities field in create/edit sidenote mode when parent note is not editable
                            // disable entities field in edit note mode when one of sidenotes is note editable
                            if (ctrl.componentType === 'entity-input' && (this._noteAction === NoteActions.createSidenote
                                || this._noteAction === NoteActions.editSidenote || this._noteAction === NoteActions.editNote)) {
                                ctrl.disabled = this._disableEntityField;
                            }
                            // only 1 entity in edit draft dialog and it's Uncategorized. hide it.
                            if (adhocId === 'entities' && this._previousTemplateValueSet[adhocId][ctrl.componentType].value.length === 1
                                && this._previousTemplateValueSet[adhocId][ctrl.componentType].value
                                === businessConstants.entity.Uncategorized_Fixed_ID) {
                                ctrl.staticDefaultValue = [];
                            } else if (ctrl.componentType === 'tb-input') {
                                // tslint:disable-next-line: max-line-length
                                ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value.split('\r\n').join('\n');
                            } else if (ctrl.componentType === 'displaydate-input' || ctrl.componentType === 'date-input') {
                                if (ctrl.componentType === 'displaydate-input' && isEvent) {
                                    ctrl.readOnly = true;
                                    ctrl.staticDefaultValue = new Date().getTime();
                                } else {
                                    if (this._previousTemplateValueSet[adhocId][ctrl.componentType].value !== '') {
                                        // tslint:disable-next-line: max-line-length
                                        ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value.getTime();
                                    } else {
                                        ctrl.staticDefaultValue = '';
                                    }
                                }
                            } else if (ctrl.componentType === 'ckeditor-input') {
                                this._isPreNoteEntryForm = false;
                                // Already has ctrl.NotebodyDetails. Add below properties for Notebody/EntryForm usage.
                                ctrl.entryId = this.editingEntryId;
                                ctrl.noteTypeId = this._noteTypeId;
                                // check isPlugInEditNoteMode&&editnote logic in notebody
                                ctrl.isPlugInEditNoteMode = this.isPlugInEditNoteMode;
                                // if last note type is EntryForm, clear note body in Note dialog;
                                // 1.if current note type is EntryForm , the note body class will load content as its own logic;
                                // 2.if current note type is non-EntryForm, the note body class use staticDefaultValue directly.
                                if (this._isPreNoteEntryForm) {
                                    ctrl.staticDefaultValue = '';
                                } else {
                                    // or else, kept the note body content.
                                    ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value;
                                }
                                // keep current status.
                                if (ctrl.notebodyDetails) {
                                    this._isPreNoteEntryForm = ctrl.notebodyDetails.prepopulateTemplateChecked;
                                }
                            } else {
                                ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value;
                            }
                        }
                    }
                }
            }
        }
        return config;
    }

    // include set blastemail data as static value
    setStaticDefaultValueForCreate(config: any) {
        const entityIdList: Array<String> = new Array<String>();
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this.setStaticDefaultValueForCreate(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    // set ctrl note action first
                    ctrl.noteAction = this._noteAction;
                    ctrl['prefixId'] = '';
                    ctrl[isSwitchNote] = false;
                    this.processingWidthForEventWidth(ctrl);
                }
                if (ctrl.componentType === ComponentTypes.displaydate) {
                    ctrl.readOnly = true;
                }

                if (this._noteAction === NoteActions.createNote && this._officeAddIn) {
                    // set defaul value for office add-in
                    if (ctrl.componentType === ComponentTypes.subject) {
                        ctrl.staticDefaultValue = this._officeAddIn.subject;
                    } else if (ctrl.componentType === ComponentTypes.notebody) {
                        if (AddInGlobalModel.currentAddInDepositType === AddInDepositType.ADDINALL) {
                            // Copy from addin code by alex,I guess this is means remove some special element from body.
                            ctrl.staticDefaultValue = this._officeAddIn.body.replace(/<o:p>&nbsp;<\/o:p>/g, '');
                        } else {
                            // do not need to show note body in only email / only file mode.
                            ctrl.staticDefaultValue = '';
                        }
                    } else if (ctrl.componentType === ComponentTypes.source) {
                        // set source id and source
                        if (this._officeAddIn.source) {
                            ctrl.staticDefaultValue = this._officeAddIn.source.id;
                            ctrl.staticDefaultObject = this._officeAddIn.source;
                        }
                    }
                }
            }
        }
        return config;
    }

    /**
     * if hasGotLabelWidth equals false ,will traverse the config until hasGotLabelWidth equals false;
     * notice: when config only group .need caculate after Group iterates through to the normal template;
     * @param ctrl current crtrl config
     */
    processingWidthForEventWidth(ctrl) {
        if (!this.hasGotLabelWidth) {
            if (ctrl.labelWidth > 0) {
                this.eventLabelWidth = Math.floor(ctrl.labelWidth * this._widthFactor);
                this.eventLabelWidth = this.eventLabelWidth > 70 ? this.eventLabelWidth : 70;
                this.eventContentWidth = this.dialogWidth - this.eventLabelWidth - 80 - 5;
                this.hasGotLabelWidth = true;
            }
        }
    }

    processingDataFromJson(config: any) {
        this.isShowEventArea = false;
        this.hasGotLabelWidth = false;
        this._tplConfig = [];
        for (const row of config) {
            const newRow = row.concat();
            for (const ctrl of newRow) {
                ctrl['prefixId'] = '';
                ctrl.width = Math.floor(ctrl.width * this._widthFactor);
                this.processingWidthForEventWidth(ctrl);
                if (ctrl.componentType === 'entity-input' && this._currentEntity) {
                    ctrl.staticDefaultValue = this._currentEntity.id;
                } else if (ctrl.componentType === 'ckeditor-input') {
                    ctrl.entryId = this.editingEntryId;
                    ctrl.noteTypeId = this._noteTypeId;
                    ctrl.isPlugInEditNoteMode = this.isPlugInEditNoteMode; // EntryForm needs it.
                }
                ctrl.noteAction = this._noteAction;
                if (ctrl.labelWidth > 0) {
                    ctrl.labelWidth = Math.floor(ctrl.labelWidth * this._widthFactor);
                    ctrl['controlWidth'] = ctrl.width - ctrl.labelWidth - 5;
                } else {
                    ctrl['controlWidth'] = ctrl.width - 5;
                }
                ctrl['widthFactor'] = this._widthFactor;
            }
            this._tplConfig.push(newRow);
        }
        this.isShowEventArea = true;

        if (this.isSingleTemplate) {
            this.singleLayerConfig = [];
            this._processTemplateForSingleLayer(this._tplConfig);
        }
        return this._tplConfig;
    }


    /**
     *
     * set layout with single layer and responsive.
     * @private
     * @param {*} config
     * @memberof NoteDialogComponent
     */
    private _processTemplateForSingleLayer(config) {
        this.dialogWidth = width100;
        config.forEach(verticalItems => {
            verticalItems.isVerticalTemplate = true;
            verticalItems.forEach(ctrl => {
                ctrl.isVerticalTemplate = true;
                // responsive layout
                ctrl.width = width100;
                ctrl.labelWidth = width100;
                ctrl.controlWidth = width100;
                // frist layer group should set individual style.
                if (ctrl.componentType === 'group') {
                    ctrl.isFirstLayer = true;
                }
                // priority move to header.
                if (ctrl.componentType === 'priority-input') {
                    this.sentimentConfig = ctrl;
                } else {
                    // set all template control an exclusive line.
                    this.singleLayerConfig.push(ctrl);
                }
            });
        });
    }

}
